import { ProgressContainer as Component } from '@local/webcomponents-progress-container';
import {
  THEME_DEFAULT,
  THEME_NYAN_CAT
} from '@local/webcomponents-progress-multi/_lib/constants.js';

export function ProgressContainer(props) {
  const theme =
    sessionStorage.getItem('accent') === 'rainbow'
      ? THEME_NYAN_CAT
      : THEME_DEFAULT;
  return Component({ ...props, theme });
}
